// Translations for the Library page.
const libraryDict = [
  { en: "CBA & Contracts / Library", sw: "CBA & Mikataba / Library" },
  { en: "Download PDF", sw: "Pakua PDF" },
  { en: "No documents uploaded.", sw: "Hakuna nyaraka zilizopakiwa." },
];

export default libraryDict;
